import { coreUtils } from '@adc/ui-morpheus'
import * as graph from '@adc/sdk'

export const NONE = 'NONE'

export const fundStatuses = [
  // TODO: remove this status when we upgrade to semantic-ui 2.4 and can make the dropdown clearable
  // https://semantic-ui.com/introduction/new.html
  { value: NONE, text: 'None' },
  { value: 'PENDING', text: 'Pending' },
  { value: 'APPROVED', text: 'Approved' },
  { value: 'DENIED', text: 'Denied' },
  { value: 'SUSPENDED', text: 'Suspended' },
]

export const userStatuses = [
  { value: 'CONFIRMED', text: 'Confirmed' },
  { value: 'PENDING', text: 'Pending' },
  { value: 'SUSPENDED', text: 'Suspended' },
]

export const clientAuthorizationHttpMethods = [
  { value: 'GET', text: 'GET' },
  { value: 'POST', text: 'POST' },
  { value: 'PUT', text: 'PUT' },
  { value: 'DELETE', text: 'DELETE' },
]

export const identityVerificationStatuses = [
  {
    value: 'VERIFICATION_IN_PROGRESS',
    text: 'Verification In Progress',
    disabled: true,
  },
  { value: 'APPROVED_VERIFIED', text: 'Verified', disabled: true },
  { value: 'NOT_VERIFIED', text: 'Not Verified', disabled: true },
  { value: 'REJECTED_FRAUD', text: 'Rejected: Fraud', disabled: true },
  { value: 'REJECTED_DUPLICATE', text: 'Rejected: Duplicate', disabled: true },
  { value: 'REJECTED_OTHER', text: 'Rejected: Other', disabled: true },
  { value: 'TOO_MANY_ATTEMPTS', text: 'Too Many Attempts', disabled: true },
  { value: 'APPROVED_MANUALLY', text: 'Manually Approved' },
  { value: 'REJECTED_MANUALLY', text: 'Manually Rejected' },
]

export const serviceType = [
  { value: 'PROPERTY', text: 'Property' },
  { value: 'LISTING', text: 'Listing' },
  { value: 'TRUSTEE_WEB_SERVICE', text: 'Trustee Web Service' },
  { value: 'PHOTO_ORDER_MANAGEMENT', text: 'Photo Order Management' },
  { value: 'MEDIA_INTAKE', text: 'Media Intake' },
  { value: 'FINANCE', text: 'Finance' },
  { value: 'LISTING_REO_INTAKE', text: 'Listing Reo Intake' },
  { value: 'INTAKE', text: 'Intake Automation' },
]

export const status = [
  { value: 'SUCCESS', text: 'Success' },
  { value: 'FAILURE', text: 'Failure' },
]

// Schedule (events/venues)
export const daysOfWeek = [
  { value: '1', text: 'Monday' },
  { value: '2', text: 'Tuesday' },
  { value: '3', text: 'Wednesday' },
  { value: '4', text: 'Thursday' },
  { value: '5', text: 'Friday' },
  { value: '6', text: 'Saturday' },
  { value: '0', text: 'Sunday' },
]

export const daysOfWeekShortForm = [
  { value: '1', text: 'Mon' },
  { value: '2', text: 'Tue' },
  { value: '3', text: 'Wed' },
  { value: '4', text: 'Thu' },
  { value: '5', text: 'Fri' },
  { value: '6', text: 'Sat' },
  { value: '0', text: 'Sun' },
]

export const regions = [
  { value: 'ALL_US', text: 'All US' },
  { value: 'NORTHEAST', text: 'Northeast' },
  { value: 'SOUTHEAST', text: 'Southeast' },
  { value: 'MIDWEST', text: 'Midwest' },
  { value: 'SOUTHWEST', text: 'Southwest' },
  { value: 'PACIFIC_NORTHWEST', text: 'Pacific Northwest' },
  { value: 'CALIFORNIA_NEVADA', text: 'California Nevada' },
  { value: 'NORTHERN_US', text: 'Northern US' },
  { value: 'SOUTHERN_US', text: 'Southern US' },
  { value: 'WESTERN_US', text: 'Western US' },
  { value: 'EASTERN_US', text: 'Eastern US' },
  { value: 'NORTHWESTERN_US', text: 'Northwestern US' },
  { value: 'SOUTHERN_CA', text: 'Southern CA' },
  { value: 'NORTHERN_CA', text: 'Northern CA' },
]

export const eventType = [
  { value: 'LIVE', text: 'Live' },
  { value: 'ONLINE', text: 'Online' },
  { value: 'THIRD_PARTY', text: '3rd Party' },
]

export const venueType = [
  { value: 'LIVE', text: 'Live' },
  { value: 'ONLINE', text: 'Online' },
  { value: 'THIRD_PARTY', text: '3rd Party' },
]

export const venueEventType = [
  { value: 'TRUSTEE', text: 'Trustee' },
  { value: 'NON_TRUSTEE', text: 'Non-trustee' },
]

export const venueSetting = [
  { value: 'COURTHOUSE', text: 'Courthouse' },
  { value: 'BALLROOM', text: 'Ballroom' },
  { value: 'ONLOCATION', text: 'On Location' },
]

export const venueClassification = [
  { value: 'TRUSTEE_STANDARD', text: 'Trustee Standard' },
  { value: 'TRUSTEE_CONVERSION', text: 'Trustee Conversion' },
]

export const trusteeSalesChannel = [
  { value: 'AUCTIONEERING', text: 'Auctioneering' },
  { value: 'CONCIERGE', text: 'Concierge' },
]

export const productOptions = Object.values(graph.enums.ProductType).map(
  product => {
    const disabledProducts = [
      graph.enums.ProductType.Trustee,
      graph.enums.ProductType.FclMarketing,
    ]

    return {
      value: product,
      text: coreUtils.formatters.formatEnum(product),
      disabled: disabledProducts.includes(product),
    }
  }
)

export const personaTypeOptions = [
  { value: 'BIDDER', text: 'Bidder' },
  { value: 'BUYER', text: 'Buyer' },
  { value: 'NOVICE', text: 'Novice' },
  { value: 'TRUSTED_BIDDER', text: 'Trusted Bidder' },
  { value: 'TRUSTED_BUYER', text: 'Trusted Buyer' },
]
